import React from 'react';
import './DiseaseChart.css';

const DiseaseChart = ({ value = 200, totalValue = 3000 }) => {
  const percentage = totalValue ? (value / totalValue) * 100 : 0;

  return (
    <div className="disease-progress-container">
      {/* 背景 */}
      <div className="disease-progress-bg" />

      {/* 进度条 */}
      <div
        className="disease-progress-segment"
        style={{ width: `${percentage}%` }}
      />

      {/* 标签 */}
      <div className="disease-label">
        {value}人 ({percentage.toFixed(1)}%)
      </div>
    </div>
  );
};

export default DiseaseChart;
